import api from './api';

const ENDPOINT = 'trainings';

const TrainingService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  answer: (id, answers) => api.post(`${ENDPOINT}/${id}/answer`, { answers }),
};

export default TrainingService;
